import React from 'react';
import { DatasetCard } from '../../atoms/training/DatasetCard';

interface Dataset {
  id: number;
  name: string;
  size: string;
  records: number;
  status: 'processed' | 'processing' | 'pending';
  quality: number;
}

interface DatasetsListProps {
  datasets: Dataset[];
  onViewDataset?: (id: number) => void;
  onEditDataset?: (id: number) => void;
}

export const DatasetsList: React.FC<DatasetsListProps> = ({
  datasets,
  onViewDataset,
  onEditDataset,
}) => {
  return (
    <div className="space-y-4">
      {datasets.map((dataset) => (
        <DatasetCard
          key={dataset.id}
          name={dataset.name}
          size={dataset.size}
          records={dataset.records}
          status={dataset.status}
          quality={dataset.quality}
          onView={() => onViewDataset?.(dataset.id)}
          onEdit={() => onEditDataset?.(dataset.id)}
        />
      ))}
    </div>
  );
};
